import Select from "react-select";
import React, { useContext, useEffect, useMemo, useState } from "react";
import Context from "../../../../context/AlertContext";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import "./offlinedata.scss";
import ButtonMedium from "../../../Buttons/ButtonMedium/ButtonMedium";
import { useRef } from "react";
import constants from "../../../../constants";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import exportPdf from "../../Dashboard/ExportPdf";
import Checkbox from "../../../CommonComponents/Checkbox";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
function Attandaceoffline() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { renderDataToPDF } = exportPdf();
  const { sessionDetails, setIsLoaded, isLoaded } = useContext(Context);
  const [checkedPresent, setCheckedPresent] = useState(false);
  const {
    setSessionDetails,

    setMsg,

    setShow,

    setTitle,
    setIsUnAuth,
    setShowNotify
  } = useContext(Context);
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();


  const [data, setData] = useState([]);
  const [status, setStatus] = useState({});

  const [selectedCellStatus, setSelectedCellStatus] = useState({});
  const [searchParms] = useSearchParams();
  const sessionId = searchParms.get("sessionid");
  //const [isLoading, setisLoading] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
    const url = `node/admin/batch/offlinedata/${sessionDetails.id}`;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data.data);
        //setSearchText(" ");
        setIsLoaded(false);
        // console.log("response.data.data", response.data.data);
        const resultForAtt = {};
        response.data.data.forEach((item) => {
          resultForAtt[item.userid] =
            item.finalStatus === null ? item.status : item.finalStatus;
        });
        setStatus(resultForAtt);
        // console.log("resultForAtt", resultForAtt);
        setSelectedCellStatus(resultForAtt);
      })
      .catch((error) => {
        setIsLoaded(false);
        console.error(error);
        if (error.message.includes("403")) {
          setShow(true);
          setTitle("Error");
          setIsUnAuth(true);
          setMsg("You have been logged-out due to inactivity. Login again.");
        }
      });
  }, [sessionDetails]);

  const [reportSent, setReportSent] = useState(false); // State to track whether the report has been sent
  const [ascOrder, setAscOrder] = useState(false);
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const handleSendReport = async () => {
    setIsLoaded(true);
    const emailRecipients = selectedUsersData.map((user) => user.label);
    if (emailRecipients.length <= 0) {
      setIsLoaded(false);
      setShow(true);
      setMsg("Please Select Recipient's emails");
      setTitle("Warning!");

      return;
    }

    try {
      setReportSent(true);
      const response = await axios.post(
        "node/admin/attendance/sendmail",
        {
          recipients: emailRecipients,
          reportData: data,
          sessionName: sessionDetails.name,
          sessionTime: sessionDetails.startdate,
          mode: "offline",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Report sent successfully", response.data);
      if (response.data.resultCode === 1000) {
        setIsLoaded(false);
        setShow(true);
        setMsg("Report Sent Success");
        setReportSent(false);
        setTitle("success");
      } else {
        setIsLoaded(false);
        setShow(true);
        setMsg("Report not sent Successfully!");
        setReportSent(false);
        setTitle("Warning");
      }
    } catch (error) {
      setIsLoaded(false);
      setReportSent(false);
      setShow(true);
      setMsg("Error in sending Report!");
      setTitle("Error !");

      console.error("Error sending report", error);
    }
  };

  const filterBy = (column) => {
    let currentOrder = !ascOrder;
    let sort1;
    if (column === "name") {
      if (currentOrder) {
        sort1 = [...filteredData].sort((a, b) =>
          a.firstname.trim().localeCompare(b.firstname.trim())
        );
      } else {
        sort1 = [...filteredData].sort((a, b) =>
          b.firstname.trim().localeCompare(a.firstname.trim())
        );
      }
    } else if (column === "email") {
      if (currentOrder) {
        sort1 = [...filteredData].sort((a, b) =>
          a.email.trim().localeCompare(b.email.trim())
        );
      } else {
        sort1 = [...filteredData].sort((a, b) =>
          b.email.trim().localeCompare(a.email.trim())
        );
      }
    } else if (column === "traineeResponse") {
      // console.log("traineeResponse", filteredData);
      if (currentOrder) {
        sort1 = [...filteredData].sort((a, b) => a.status - b.status);
      } else {
        sort1 = [...filteredData].sort((a, b) => b.status - a.status);
      }
    } else if (column === "actualAttendance") {
      // console.log("actualAttendance", filteredData);
      if (currentOrder) {
        sort1 = [...filteredData].sort(
          (a, b) => selectedCellStatus[a.userid] - selectedCellStatus[b.userid]
        );
      } else {
        sort1 = [...filteredData].sort(
          (a, b) => selectedCellStatus[b.userid] - selectedCellStatus[a.userid]
        );
      }
    }
    setData(sort1);
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  // const handleSelectAll = (event) => {
  //   const isChecked = event.target.checked;
  //   setSelectedRows(isChecked ? data.map((session) => session.userid) : []);
  // };

  // const handleSelectRow = (userId) => {
  //   setSelectedRows((prevSelected) => {
  //     if (prevSelected.includes(userId)) {
  //       return prevSelected.filter((id) => id !== userId);
  //     } else {
  //       return [...prevSelected, userId];
  //     }
  //   });
  // };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const filteredData = useMemo(() => {
    if (!data || Object.keys(data).length <= 0) return [];
    console.log('data:', data);

    return data.filter((person) =>
      (person.firstname + " " + person.lastname)
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }, [data, searchText]);

  const [selectAll, setSelectAll] = useState(false);
  // const [todoItems, setTodoItems] = useState([
  //   { id: 1, text: "To-Do Item 1", completed: false },
  //   // Add more items here...
  // ]);

  // const handleToggleSelectAll = () => {
  //   setSelectAll(!selectAll);
  //   setTodoItems(todoItems.map((item) => ({ ...item, completed: !selectAll })));
  // };

  // const handleToggleItem = (itemId) => {
  //   setTodoItems(
  //     todoItems.map((item) =>
  //       item.id === itemId ? { ...item, completed: !item.completed } : item
  //     )
  //   );
  // };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (sessionId) {
      fetchSessionDetailsById();
    }
  }, []);

  const fetchSessionDetailsById = async () => {
    try {
      setIsLoaded(true);
      const response = await axios.get(`/node/admin/attendance/session/${id}/${sessionId}`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      console.log("response from api:", response);
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          msg: `${response.data.msg || "Something went wrong"}`,
          title: "Success !",
        });
      }

      setSessionDetails(response.data.data[0]);
      setData(response.data.data);
      // // createdby = response.data.data[0].sessiondatda;
      // val = response.data.data[0].id;

    } catch (error) {
      console.log("Error:", error);
      useCommonFunctionHks.getCatchBlockDetails(error);
    }
    finally {
      setIsLoaded(false);
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const [users, setUsers] = useState([]); // Initialize with an empty array

  useEffect(() => {
    const url = `node/admin/getemails/1/0`;

    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // Map the response data to match the format of the existing data
        const formattedData = response.data.data.map((item) => ({
          id: item.id,
          name: item.firstname,
          email: item.email,
        }));
        setUsers(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // const handleExportCSV = () => {
  //   const doc = new jsPDF();

  //   const fileName = `report_session${sessionDetails.id}.pdf`;

  //   const table = document.querySelector(".session-table-container");

  //   // Add header content
  //   const headerContent =
  //     "Welcome to Gradious, a platform that ignites the spark of learning and inspiration within every student's journey!."; // Your header content
  //   const headerHeight = 15; // Adjust the header height as needed
  //   doc.setFontSize(12);
  //   const textLines = doc.splitTextToSize(headerContent, 190);
  //   doc.text(10, headerHeight, textLines);

  //   html2canvas(table).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");

  //     const imgHeight = (canvas.height * 190) / canvas.width;
  //     const remainingPageHeight = doc.internal.pageSize.height - headerHeight;

  //     if (imgHeight < remainingPageHeight) {
  //       doc.addImage(imgData, "PNG", 10, headerHeight + 10, 190, imgHeight);

  //       const footerContent = `Page ${
  //         doc.internal.getCurrentPageInfo().pageNumber
  //       } \nJoin us on an exhilarating adventure where education meets elegance, and knowledge blossoms into breathtaking beauty.`;
  //       const footerHeight = 10;
  //       doc.setFontSize(10);

  //       doc.text(
  //         footerContent,
  //         10,
  //         doc.internal.pageSize.height - footerHeight
  //       );

  //       doc.save(fileName);

  //       setShow(true);
  //       setMsg("File Downloaded Success");
  //       setTitle("Success");
  //     } else {
  //       doc.addPage();

  //       doc.setFontSize(12);
  //       doc.text(10, 15, textLines);

  //       const remainingPageHeightNew =
  //         doc.internal.pageSize.height - headerHeight;
  //       const imgHeightNew = remainingPageHeightNew - 20; // Adjust the margin
  //       doc.addImage(imgData, "PNG", 10, headerHeight + 10, 190, imgHeightNew);

  //       const footerContent = `Page ${
  //         doc.internal.getCurrentPageInfo().pageNumber
  //       } \nJoin us on an exhilarating adventure where education meets elegance, and knowledge blossoms into breathtaking beauty.`;
  //       const footerHeight = 10; // Adjust the footer height as needed
  //       doc.setFontSize(10);
  //       doc.text(
  //         footerContent,
  //         10,
  //         doc.internal.pageSize.height - footerHeight
  //       );

  //       doc.save(fileName);

  //       setShow(true);
  //       setMsg("File Downloaded Success");
  //       setTitle("Success");
  //     }
  //   });
  // };

  // function addWaterMark(doc) {
  //   var totalPages = doc.internal.getNumberOfPages();

  //   for (let i = 1; i <= totalPages; i++) {
  //     doc.setPage(i);
  //     let imgData =
  //       "data:image/png;base64,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";
  //     const x = doc.internal.pageSize.width;
  //     const y = doc.internal.pageSize.height;
  //     let horizontalPos = x / 2;
  //     let verticalPos = y / 3;
  //     doc.addImage(imgData, "SVG", 10, verticalPos);

  //   }

  //   return doc;
  // }

  // function addFooters(doc) {
  //   const pageCount = doc.getNumberOfPages();
  //   const horizontalPosFooter1 =
  //     doc.getCurrentPagseInfo().pageContext.mediaBox.bottomLeftX + 5;
  //   const horizontalPosFooter2 =
  //     doc.getCurrentPageInfo().pageContext.mediaBox.topRightX - 70;
  //   const verticalPosFooter =
  //     doc.getCurrentPageInfo().pageContext.mediaBox.topRightY - 35;

  //   const horizontalPosHeader =
  //     doc.getCurrentPageInfo().pageContext.mediaBox.topRightX - 145;
  //   const verticalPosHeader =
  //     doc.getCurrentPageInfo().pageContext.mediaBox.topRightY - 805;

  //   doc.setFontSize(8);
  //   for (let i = 1; i <= pageCount; i++) {
  //     doc.setPage(i);
  //     doc.text(
  //       `${sessionDetails.name} - Attendance Report`,
  //       horizontalPosHeader,
  //       verticalPosHeader
  //     );
  //     doc.text(
  //       "Copyright Gradious Technologies (P) Ltd - 2024",
  //       horizontalPosFooter1,
  //       verticalPosFooter
  //     );
  //     doc.text(
  //       `Page ${i} of ${pageCount}`,
  //       horizontalPosFooter2,
  //       verticalPosFooter
  //     );
  //   }
  //   return doc;
  // }

  // const handleExportCSV = () => {
  //   const A4_HEIGHT = 841.89;
  //   const A4_WIDTH = 595.28;
  //   const WIDTH_MARGIN = 20;
  //   const HEIGHT_MARGIN = 30;
  //   let doc = new jsPDF("p", "pt", "a4");
  //   const fileName = `report_session${sessionDetails.id}.pdf`;

  //   const table = document.querySelector(".session-table-container");

  //   html2canvas(table).then((canvas) => {
  //     const canvasWidth = canvas.width;
  //     const canvasHeight = canvas.height;

  //     const imgWidth = A4_WIDTH - 2 * WIDTH_MARGIN;
  //     const imgHeight = (imgWidth / canvasWidth) * canvasHeight;

  //     const imgData = canvas.toDataURL("image/png", 1.0);
  //     const usedHeight = HEIGHT_MARGIN;
  //     doc.addImage(
  //       imgData,
  //       "PNG",
  //       WIDTH_MARGIN,
  //       usedHeight + 10,
  //       imgWidth,
  //       imgHeight
  //     );
  //     doc = addWaterMark(doc);
  //     doc = addFooters(doc);

  //     doc.setFillColor(255, 255, 255);
  //     doc.rect(0, 0, A4_WIDTH, HEIGHT_MARGIN, "F");
  //     doc.rect(0, A4_HEIGHT - HEIGHT_MARGIN, A4_WIDTH, HEIGHT_MARGIN, "F");
  //     doc.save(fileName);
  //     setShow(true);
  //     setMsg("File Downloaded Success");
  //     setTitle("Success");
  //   });
  // };

  const [textFind, setTextFind] = useState("");
  const [allSelect, setAllSelect] = useState(false);
  const [userClean, setUserClean] = useState(users);

  // const handleSearch = (event) => {
  //   const searchText = event.target.value;
  //   setTextFind(searchText);

  //   const filteredUsers = users.filter(
  //     (user) =>
  //       user.name.toLowerCase().includes(searchText.toLowerCase()) ||
  //       user.email.toLowerCase().includes(searchText.toLowerCase())
  //   );
  //   setUserClean(filteredUsers);
  // };

  // const handleSelectAl = () => {
  //   setSelectAll(!selectAll);
  //   setUserClean(userClean.map((user) => ({ ...user, selected: !selectAll })));
  // };

  // const handleselect = (userId) => {
  //   setUserClean(
  //     userClean.map((user) =>
  //       user.id === userId ? { ...user, selected: !user.selected } : user
  //     )
  //   );
  // };
  // const handleCancel = () => {
  //   setSelectedUsersData([]); // Clear selected user data
  // };

  // const [unsavedChanges, setUnsavedChanges] = useState(false);
  // const [sessions, setSessions] = useState([]); // Initialize with an empty array
  const [updatedSessions, setUpdatedSessions] = useState({});

  // const [updatedSessionDetails, setUpdatedSessionDetails] = useState([]);

  // const [savedSessions, setSavedSessions] = useState([]);

  const handleToggleCellStatus = (sessionId) => {
    // console.log("session not userid it is", sessionId);
    setSelectedCellStatus((prevStatus) => {
      // console.log("set%%%", prevStatus);
      const newStatus = {
        ...prevStatus,
        [sessionId]: getNextStatus(prevStatus[sessionId]),
      };
      // console.log("newwwwww>>>>>>>status", newStatus);
      return newStatus;
    });
  };

  const getNextStatus = (currentStatus) => {
    // console.log("current status %%%%%%", currentStatus);
    if (
      currentStatus === constants.ATTENDANCE_STATUS.ABSENT ||
      currentStatus == null
    )
      return constants.ATTENDANCE_STATUS.PRESENT;
    if (currentStatus === constants.ATTENDANCE_STATUS.PRESENT)
      return constants.ATTENDANCE_STATUS.ABSENT;
    if (currentStatus === constants.ATTENDANCE_STATUS.NO_RESPONSE)
      return constants.ATTENDANCE_STATUS.PRESENT;
    return constants.ATTENDANCE_STATUS.ABSENT;
  };

  const handleSaveChanges = () => {
    setIsLoaded(true);
    // console.log("data>>>>>>>>>347", data);
    const updatedSessions = data.map((session) => {
      // console.log("session>>>>>>>349", session);
      const newStatus = selectedCellStatus[session.userid] || session.status;
      return { ...session, finalStatus: newStatus };
    });
    // console.log("updatedSessions&&&&&&&%%%%%%", updatedSessions);
    setUpdatedSessions(updatedSessions);

    const savedData = updatedSessions.map((session) => ({
      sessionDetails: sessionDetails.id,
      id: session.userid,
      status: session.status,
      finalStatus: session.finalStatus,
    }));
    saveChangesToBackend(savedData);
    // setSavedSessions(savedData);
  };

  const handleCancelChanges = () => {
    setSelectedCellStatus({});
    setSessionDetails({});
    navigate(`/batches/${id}/event`);
  };

  useEffect(() => {
    setAscOrder(!ascOrder);
  }, [data]);

  // useEffect(() => {
  const handleNavigateToEvent = () => {
    setShowNotify(false);
    navigate(`/batches/${id}/event`);
  };

  const saveChangesToBackend = async (savedSessions) => {
    setIsLoaded(true);
    try {
      const response = await axios.post(
        "node/admin/attendance/savechanges",
        savedSessions,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setIsLoaded(false);

      console.log("Save changes response:", response.data);
      if (response.data.resultCode == constants.RESULT_STATUS.SUCCESS) {
        // setShow(true);
        // setMsg(response.data.msg);
        // setTitle("Success");
        // navigate(`/batches/${id}/event`);

        setShowNotify({
          show: true,
          title: "Success",
          msg: response.data.msg,
          primaryButtonFunction: handleNavigateToEvent,
        });
      } else {
        setShow(true);
        setMsg("Something went wrong while updating attendnce!");
        setTitle("warning");
      }
    } catch (error) {
      setIsLoaded(false);
      if (error.message.includes("403")) {
        setShow(true);
        setTitle("Error");
        setIsUnAuth(true);
        setMsg("You have been logged-out due to inactivity. Login again.");
      } else {
        setShow(true);
        setMsg("Error Saving attendnance");
        setTitle("Error !");
        console.error("Error saving changes:", error);
      }
    }
  };

  // console.log(savedSessions);
  // saveChangesToBackend();
  // }, [savedSessions]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedUsersData, setSelectedUsersData] = useState([]);
  const [inputValue, setInputValue] = useState(""); // State to store the current input value
  const options = users.map((user) => ({
    value: user.id,
    label: user.email,
  }));

  const handleSelect = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    setSelectedUsersData(selectedOptions);
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    if (isValidEmail(newValue)) {
      const newOption = { value: newValue, label: newValue };

      setSelectedOptions([...selectedOptions, newOption]);
      setSelectedUsersData([...selectedOptions, newOption]);

      setInputValue("");
    }
  };

  function handleExportPdf() {
    let manipulateData = filteredData.map((trainee) => {
      return {
        Name: trainee.firstname + " " + trainee.lastname,
        Email: trainee.email,
        TraineeResponse:
          trainee.status == constants.ATTENDANCE_STATUS.NO_RESPONSE
            ? "NR"
            : trainee.status == constants.ATTENDANCE_STATUS.PRESENT
              ? "P"
              : "A",
        Time: trainee.responseTime == null ? "-" : trainee.responseTime,
        Actual_Attendance:
          trainee.finalStatus == constants.ATTENDANCE_STATUS.NO_RESPONSE
            ? "NR"
            : trainee.finalStatus == constants.ATTENDANCE_STATUS.PRESENT
              ? "P"
              : "A",
      };
    });
    //console.log("filteredData>>>",manipulateData[0]);
    renderDataToPDF(manipulateData, "portrait", "a4", sessionDetails.name);
  }

  const isValidEmail = (value) => {
    return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{3,4}$/.test(value);
  };

  const getStatus = (status) => {
    // console.log("sessionDetails%%%%%%%%", sessionDetails);
    let result = { color: "", text: "", st: "" };
    const { modifieddate, expiryTime } = sessionDetails;
    const modifiedDateObject = new Date(modifieddate);
    const expirationDate = new Date(
      modifiedDateObject.getTime() + expiryTime * 60000
    );
    const currentDate = new Date();
    if (status === constants.ATTENDANCE_STATUS.PRESENT) {
      result.color = "#2AC351";
      result.text = "Present";
    } else if (status === constants.ATTENDANCE_STATUS.ABSENT) {
      result.color = "#F55533";
      result.text = "Absent";
    }
    // if (expirationDate > currentDate)
    else {
      result.color = "#8E9093";
      result.text = "No Response";
      result.st = constants.ATTENDANCE_STATUS.NO_RESPONSE;
    }
    // else {
    //   result.color = "#F55533";
    //   result.text = "Absent";
    //   result.st = constants.ATTENDANCE_STATUS.ABSENT;
    // }
    return result;
  };

  function setAllValuesAsPresentToObject(obj, value) {
    Object.keys(obj).forEach((key) => {
      obj[key] = value;
    });
    return obj;
  }

  const handlePresentAll = () => {
    if (!checkedPresent) {
      let newStatus = { ...status };
      const result = setAllValuesAsPresentToObject(newStatus, 1);
      setSelectedCellStatus(result);
    }
    else {
      let oldStatus = { ...status };
      setSelectedCellStatus(oldStatus);
    }
    setCheckedPresent(!checkedPresent);
  };
  //console.log(getStatus())

  // console.log("jfjjjjjjjjjjjjjjjjjjjjjj", selectedUsersData);
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="offline-table">
      <div className="attendanceOfflineSessioname">
        <h3>Session Name : </h3> <h3>{sessionDetails.name}</h3>
      </div>
      <div className="toolbar">
        <div className="attndancesearch-bar">
          <input
            type="text"
            className="searchattendees"
            value={searchText}
            onChange={handleSearchChange}
            placeholder="  Search"
          />
          <span
            className="attendancesearch-icon"
            onClick={() => setSearchText("")}
          ></span>
        </div>
        <div>
          <Checkbox
            checked={checkedPresent}
            text="Mark All Present"
            disabled={false}
            onChange={handlePresentAll}
          />
        </div>
        <div className="vinn">
          <div className="attendancedropdown">
            <Select
              options={options}
              placeholder="Type or Select Emails To Send Mails"
              value={selectedOptions}
              onChange={handleSelect}
              isSearchable={true}
              isMulti
              className="dynamic-width-select"
              onInputChange={handleInputChange} // Listen to input changes
              inputValue={inputValue} // Set the input value
            />
          </div>

          {reportSent ? (
            <strong style={{ color: "red" }}>
              &nbsp;&nbsp;&nbsp;Report Sendingin Progress...&nbsp;&nbsp;
            </strong>
          ) : (
            <button className="send-report-button" onClick={handleSendReport}>
              Send Report &nbsp;
            </button>
          )}

          <button
            className="export-button"
            //renderDataToPDF = (data, orientation, Format, dashBoardname)
            onClick={handleExportPdf}
          // onClick={handleExportCSV}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 512 512"
            >
              <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
            </svg>
            &nbsp;Export
          </button>
        </div>
      </div>
      <div className="session-table-container">
        <table className="session-table">
          <thead className="session-head">
            <tr>
              {/* <th style={{ width: "74px", height: "64px" }}>
                <Form.Check
                  type="checkbox"
                  checked={selectedRows.length === filteredData?.length}
                  onChange={handleSelectAll}
                />
              </th> */}
              <th
                className="session-tableHead"
                onClick={() => filterBy("name")}
              >
                Name of the Student
              </th>
              <th
                className="session-tableHead"
                onClick={() => filterBy("email")}
              >
                Email ID
              </th>
              {/* <th>Batch</th> */}
              <th
                className="session-tableHead"
                onClick={() => filterBy("traineeResponse")}
              >
                Trainee response
              </th>
              <th className="session-tableHead">Time</th>
              <th
                style={{ width: "142px", height: "64px" }}
                className="session-tableHead"
                onClick={() => filterBy("actualAttendance")}
              >
                Actual Attendance
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((session) => (
              <tr key={session.userid}>
                {/* <td style={{ height: "44px" }}>
                  <Form.Check
                    type="checkbox"
                    checked={selectedRows.includes(session.userid)}
                    onChange={() => handleSelectRow(session.userid)}
                  />
                </td> */}
                <td className="session-tableData">
                  {session.firstname + " " + session.lastname}
                </td>
                <td className="session-tableData">{session.email}</td>
                {/* <td>
                  {sessionDetails.name} id: {sessionDetails.id}
                </td> */}
                <td
                  style={{
                    color: getStatus(session.status).color,
                    fontWeight: 700,
                  }}
                  className="session-tableData"
                >
                  {getStatus(session.status).text}
                </td>
                <td className="session-tableData">
                  {session.responseTime === null
                    ? "-----"
                    : new Date(session.responseTime).toLocaleString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })}
                </td>
                <td
                  className={`status-cell status-${selectedCellStatus[session.userid] ||
                    (session.status === null
                      ? getStatus(null).st
                      : session.status)
                    }`}
                  onClick={() => handleToggleCellStatus(session.userid)}
                ></td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="button-container" data-html2canvas-ignore="true">
          {/* <button className="btn btn-secondary" onClick={handleCancelChanges}>
          &nbsp; Cancel &nbsp;
        </button> */}
          <ButtonMedium btnText="Cancel" onHide={handleCancelChanges} />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ButtonMedium btnText="Save" onHide={handleSaveChanges} />
          {/* <button className="btn btn-primary" onClick={handleSaveChanges}>
          &nbsp; Save&nbsp;
        </button> */}
        </div>
        <br />
      </div>
    </div>
  );
}
export default Attandaceoffline;
